// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 67) return "js/67-5bb4a423a67b8c00a3a7.chunk.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"486":"2bf3070c09a26a09293a","755":"ceabdc13f82f7e24f26e"}[chunkId] + ".js";
};